import {
  Box,
  createStyles,
  makeStyles,
  Step,
  StepLabel,
  Theme,
} from '@material-ui/core';
import Stepper from '@material-ui/core/Stepper';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '90%',
    },
    button: {
      marginRight: 10,
    },
    instructions: {
      marginTop: 10,
      marginBottom: 10,
    },
    icon: {
      color: '#0000001F',
      '&$activeIcon': {
        color: '#6FAD37',
      },
      '&$completedIcon': {
        color: '#6FAD37',
      },
    },
    activeIcon: {},
    completedIcon: {},
  }),
);
type StepperComponentProps = {
  steps: string[];
  activeStep: number;
};
const StepperComponent = ({ steps, activeStep }: StepperComponentProps) => {
  const classes = useStyles();
  return (
    <Box style={{ height: 400 }}>
      <Stepper
        style={{ backgroundColor: '#FAFAFA' }}
        activeStep={activeStep}
        orientation="vertical"
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconProps={{
                classes: {
                  root: classes.icon,
                  active: classes.activeIcon,
                  completed: classes.completedIcon,
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
export default StepperComponent;
